import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService } from '@angular/synthrone-design/services';
import { MatDialog } from '@angular/material';
import { ErrorComponent, AlertComponent } from '@angular/synthrone-design/components';
import { DomSanitizer } from '@angular/platform-browser';
import { EndpointService } from '@angular/synthrone-design/services/endpoint/endpoint.service';

@Component({
  selector: 'platform-template-view',
  templateUrl: './platform-template-view.component.html',
  styleUrls: ['./platform-template-view.component.scss']
})

export class PlatformTemplateViewComponent implements OnInit {

  @ViewChild('csvNameContainer') csvNameContainer;
  @ViewChild('xlsxNameContainer') xlsxNameContainer;
  @ViewChild('xmlNameContainer') xmlNameContainer;
  @ViewChild('jsonNameContainer') jsonNameContainer;

  @ViewChild('csv') csv;
  @ViewChild('xlsx') xlsx;
  @ViewChild('xml') xml;
  @ViewChild('json') json;

  templateTypes: any;
  templates: any;
  platformId: string;
  platformName: string;
  platformSlug: string;
  platformMessage: string;
  isDataLoading: number = 0;
  isValid: boolean = false;

  constructor(
    private router: Router, 
    private route: ActivatedRoute, 
    protected dialog: MatDialog, 
    protected api: ApiService,
    private sanitizer: DomSanitizer,
    private endpointService: EndpointService
  ) {
  }

  ngOnInit() {
    this.templateTypes = ['csv', 'xlsx', 'json', 'xml'];
    this.platformSlug = (this.router.url).split('/')[(this.router.url).split('/').length - 1];
    this.isDataLoading++;
    this.api.makeRequest('api_system_platform_get', {
      'slug' : this.platformSlug
    }, 'publisher').subscribe(
      (result) => {
        this.isDataLoading--;
        this.platformName = result['name'];
        this.templates = result['template']
      },
      (error) => {
        this.isDataLoading--;
        const dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
        }).afterClosed().subscribe(result => {
          this.router.navigate(['/platforms']);
        });
      });
  }

  breadcrumbsFN = () => {
    return Observable.of([
      {
        breadcrumb: 'ADMINER',
        url: '/'
      },
      {
        breadcrumb: 'Manage platforms',
        url: '/platforms'
      },
      {
        breadcrumb: 'Template settings',
        url: this.router.url
      }
    ]);
  }

  public filesConfig = {
    'csv' : {
      'mimes': ['text/csv'],
      'extensions': ['csv'],
    },
    'xlsx' : {
      'mimes': ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
      'extensions': ['xlsx', 'xls'],
    },
    'json':{
      'mimes': ['application/json'],
      'extensions': ['json'],
    },
    'xml':{
      'mimes': ['text/xml' , 'application/xml'],
      'extensions': ['xml'],
    }
  };

  public getFileExtension = (file) => {
      var fileExtension = file.name.split('.');
      return fileExtension[fileExtension.length -1].toLowerCase();
  }

  private isFileSizeValid = (file, fileType) => {
    if(fileType == '*'){
        return true;
    }
    if (file.size > this.filesConfig[fileType].maxSize * 1024 * 1024) {
        return false;
    } else {
        return true;
    } 
  }

  private isFileTypeValid = (inputFile, fileType) => {
    let file = inputFile.target.files[0]
    let type = file.type;
    let name = file.name;
    var mimeTypes = {};
    var extensions = {};
    for(let i in this.filesConfig[fileType]){
        if(i == 'mimes'){
            mimeTypes[i] = this.filesConfig[fileType].mimes;
        }
        if(i == 'extensions'){
            extensions[i] = this.filesConfig[fileType].extensions;
        }
    }
    var fileExtension = this.getFileExtension(file);
    var ret = null;
    for (var key in mimeTypes) {
        if (ret != null) {
            break;
        }
        mimeTypes[key].forEach(function(item, index) {
            if (item == type) {
                ret = key;
                return false;
            }
        });
    }
    for (var key in extensions) {
        if (ret != null) {
            break;
        }
        extensions[key].forEach(function(item, index) {
            if (item == fileExtension) {
                ret = key;
                return false;
            }
        });
    }
    if (ret) {
      this.handleFileSuccess(inputFile, fileExtension);
    } else {
      this.handleFileError(fileType);
    }

    this.isFormValid();
  }

  handleFileSuccess(inputFile, fileExtension){
    const fileInputValue = inputFile.target.value.split('\\').pop().split('/').pop();
      const fileName = (fileInputValue.length !== 0) ? fileInputValue : 'test';
      if (fileExtension == 'csv') {
        this.csvNameContainer.nativeElement.innerHTML = fileName;
        this.csvNameContainer.nativeElement.classList.remove("error");;
      }
      if (fileExtension == 'xls' || fileExtension == 'xlsx') {
        this.xlsxNameContainer.nativeElement.innerHTML = fileName;
        this.xlsxNameContainer.nativeElement.classList.remove("error");;
      }
      if (fileExtension == 'json') {
        this.jsonNameContainer.nativeElement.innerHTML = fileName;
        this.jsonNameContainer.nativeElement.classList.remove("error");;
      }
      if (fileExtension == 'xml') {
        this.xmlNameContainer.nativeElement.innerHTML = fileName;
        this.xmlNameContainer.nativeElement.classList.remove("error");;
      }
  }

  handleFileError(fileType){
    if (fileType == 'csv') {
        this.csv.nativeElement.value = '';
        this.csvNameContainer.nativeElement.className += " error"
      }
      if (fileType == 'xlsx') {
        this.xlsx.nativeElement.value = '';
        this.xlsxNameContainer.nativeElement.className += " error"
      }
      if (fileType == 'json') {
        this.json.nativeElement.value = '';
        this.jsonNameContainer.nativeElement.className += " error"
      }
      if (fileType == 'xml') {
        this.xml.nativeElement.value = '';
        this.xmlNameContainer.nativeElement.className += " error"
      }
  }

  isFormValid(){
    if (
      this.csv.nativeElement.value != '' || 
      this.xlsx.nativeElement.value != '' || 
      this.json.nativeElement.value != '' || 
      this.xml.nativeElement.value != ''
    ){
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }

  download = (type:string) => {
    this.api.makeRequest('api_platform_get_template_download', {
      'slug' : this.platformSlug,
      'filetype' : type
    },  'publisher', {}, false, 'blob')
    .subscribe(
      (data:any) => {
        var blob = new Blob([data], { type: 'document' });
        var downloader = document.createElement("a");
        downloader.href = window.URL.createObjectURL(blob);
        downloader.download = 'template_' + this.platformSlug + '_' + type +'.' + type;
        downloader.click();
        downloader.remove();
      },
      (error) => {
        const dialogRef = this.dialog.open(ErrorComponent, {
        data: {
          message: error
        }
       });
      }
    );
  }

  isDownloadable = (type:string) => {
    if (this.templates[type]  === undefined) {
      return true;
    }
    return false;
  }

  fileSubmitFN = () => {

    this.isDataLoading++;
    this.api.makeRequest('api_platform_set_template', {
      'slug' : this.platformSlug,
      'csv' : this.csv.nativeElement.files[0],
      'xlsx' : this.xlsx.nativeElement.files[0],
      'json' : this.xml.nativeElement.files[0],
      'xml' : this.json.nativeElement.files[0]
    }, 'publisher').subscribe(
    (result) => {
      this.isDataLoading--;
      this.router.navigate(['/platforms']);
    },
    (error) => {
      this.isDataLoading--;
      const dialogRef = this.dialog.open(ErrorComponent, {
        data: {
          message: error
        }
      });
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/components/views/platform-template-view/platform-template-view.component.ts